import { FunctionComponent } from "react";
import NAV from "../components/NAV";

const Lesson17: FunctionComponent = () => {
  return (
    <div className="relative bg-gray-100 w-full overflow-hidden flex flex-col items-center justify-center p-[2.69rem] box-border gap-[6.88rem] text-left text-[1.56rem] text-darkgray font-nunito">
      <NAV dimensionCode="/nav@2x.png" navIconFlexShrink="unset" />
      <div className="self-stretch flex flex-row items-center justify-between">
      <a className="cursor-pointer text-darkgray no-underline" href={"/lesson16"}>
        <div className="flex-1 rounded-32xl bg-gainsboro-200 box-border h-[3.5rem] flex flex-col items-center justify-center py-[0.69rem] px-[3rem] max-w-[12.5rem] border-[1px] border-solid border-gray-300">
          <b className="relative inline-block w-[3.75rem] h-[2.06rem] shrink-0">
            Back
          </b>
        </div>
        </a>
        <div className="self-stretch flex-1 flex flex-col items-center justify-center text-center text-[2.81rem] text-white">
          <b className="self-stretch relative leading-[100%]">
            Exercise Importance
          </b>
        </div>
        <a className="cursor-pointer text-darkgray no-underline" href={"/lesson18"}>
        <div className="flex-1 rounded-32xl bg-gainsboro-200 box-border h-[3.5rem] flex flex-col items-center justify-center py-[0.69rem] px-[3rem] max-w-[12.5rem] border-[1px] border-solid border-gray-300">
          <b className="relative inline-block w-[3.75rem] h-[2.06rem] shrink-0">
            Next
          </b>
        </div>
        </a>
      </div>
      <div className="self-stretch flex flex-col items-center justify-center gap-[6.25rem] text-justify text-white font-dm-sans">
        <div className="self-stretch flex flex-row items-center justify-center gap-[6.25rem]">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <p className="m-0 text-[1.88rem]">
              <b>Why is Exercise Important?</b>
            </p>
            <p className="m-0 text-gainsboro-100">
              <span>
                <span>&nbsp;</span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  Strength training and physical fitness are essential for men's
                  overall well-being. Regular exercise offers a wide range of
                  benefits for our overall health and well-being. Some of the
                  scientifically proven advantages of exercise include:
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>&nbsp;</span>
              </span>
            </p>
            <ul className="m-0 pl-[2.06rem]">
              <li className="mb-[0rem]">
                <span>
                  <b className="font-dm-sans">
                    Enhanced Cardiovascular Health:
                  </b>
                  <span>
                    {" "}
                    Exercise helps to keep your heart and blood vessels healthy,
                    which can reduce your risk of developing cardiovascular
                    diseases such as heart disease, high blood pressure, and
                    stroke.
                  </span>
                </span>
              </li>
            </ul>
            <p className="m-0">
              <span>
                <span>&nbsp;</span>
              </span>
            </p>
            <ul className="m-0 pl-[2.06rem]">
              <li className="mb-[0rem]">
                <span>
                  <b className="font-dm-sans">{`Improved Sexual Function: `}</b>
                  <span>{`Exercise has been shown to improve sexual function in both men and women. `}</span>
                </span>
              </li>
            </ul>
            <p className="m-0">
              <span>
                <span>&nbsp;</span>
              </span>
            </p>
            <ul className="m-0 pl-[2.06rem]">
              <li className="mb-[0rem]">
                <span>
                  <b className="font-dm-sans">{`Reduced pain: `}</b>
                  <span>{`Exercise can help to reduce pain in people with chronic conditions such as arthritis, back pain, and headaches. `}</span>
                </span>
              </li>
            </ul>
            <p className="m-0">
              <span>
                <span>&nbsp;</span>
              </span>
            </p>
            <ul className="m-0 pl-[2.06rem]">
              <li className="mb-[0rem]">
                <span>
                  <b className="font-dm-sans">Improved Cognitive Function:</b>
                  <span>{` Exercise has been linked to improved cognitive function across all age groups. `}</span>
                </span>
              </li>
            </ul>
            <p className="m-0">
              <span>
                <span>&nbsp;</span>
              </span>
            </p>
            <ul className="m-0 pl-[2.06rem]">
              <li className="mb-[0rem]">
                <span>
                  <b className="font-dm-sans">Increased Lifespan:</b>
                  <span>{` Engaging in regular physical activity has been associated with a longer lifespan. `}</span>
                </span>
              </li>
            </ul>
            <p className="m-0">
              <span>
                <span>&nbsp;</span>
              </span>
            </p>
          </div>
          <img
            className="relative w-[35.69rem] h-[31.56rem] object-cover"
            alt=""
            src="/31@2x.png"
          />
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0 text-[1.88rem]">
            <b>Forging Strength</b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Strength training and physical fitness are essential for men's
                overall well-being. Here are some of the reasons why strength
                training is important for men:
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <b className="font-dm-sans">{`Testosterone Regulation: `}</b>
                <span>
                  Strength training has been shown to have a positive impact on
                  testosterone levels in men. Testosterone is a hormone that
                  plays a role in muscle development, bone density, sexual
                  health, mood regulation, and overall vitality. Regular
                  strength training can help optimize testosterone production,
                  promoting hormonal balance and enhancing various aspects of
                  men's health.
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <b className="font-dm-sans">{`Muscle Mass & Fat Reduction:`}</b>
                <span>
                  {" "}
                  Strength training stimulates muscle growth and helps increase
                  lean muscle mass. With higher muscle mass, men experience an
                  increase in their basal metabolic rate (BMR), which means they
                  burn more calories even at rest. This can aid in weight
                  management and reducing body fat. Maintaining a healthy body
                  composition through strength training contributes to better
                  overall health and reduces the risk of chronic conditions such
                  as obesity, cardiovascular diseases, and diabetes.
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <b className="font-dm-sans">{`Bone Density & Joint Health: `}</b>
                <span>
                  Strength training is crucial for maintaining strong bones and
                  joints. As men age, they become more susceptible to bone
                  density loss, which can lead to conditions like osteoporosis.
                  Resistance training, including weightlifting and
                  weight-bearing exercises, helps stimulate bone growth and
                  increases bone mineral density, reducing the risk of fractures
                  and osteoporosis.
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <b className="font-dm-sans">Enhanced Mental Health:</b>
                <span>
                  {" "}
                  Regular strength training has been linked to improved mental
                  health and well-being in men. Engaging in physical activity
                  releases endorphins, which are known as "feel-good" hormones,
                  contributing to reduced stress, anxiety, and symptoms of
                  depression. Strength training can also boost self-confidence,
                  body image, and overall self-esteem, leading to a positive
                  outlook on life.
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <b className="font-dm-sans">{`Increased Energy Levels & Vitality: `}</b>
                <span>
                  Building strength through regular exercise improves
                  cardiovascular health, enhances endurance, and increases
                  energy levels. Men who are physically fit and have good
                  muscular strength often experience increased stamina and
                  vitality, allowing them to perform daily tasks more
                  efficiently and enjoy an active lifestyle.
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <b className="font-dm-sans">{`Hormonal Balance & Longevity: `}</b>
                <span>
                  Hormonal balance is vital for men's overall health and
                  longevity. By engaging in strength training, men can promote
                  hormonal equilibrium, optimize testosterone levels, and
                  support the proper functioning of other hormones. This
                  contributes to better overall health, improved longevity, and
                  a higher quality of life.
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[6.25rem] text-gainsboro-100">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem] inline-block h-[12.69rem]">
            <p className="m-0">
              In the realm of romantic attraction, physical appearance plays a
              major role. Being fit and having a strong body not only promotes
              overall health but also has a certain appeal that can attract
              women. In this article, we will explore how fitness and a strong
              physique can enhance attractiveness and captivate the interest of
              women.
            </p>
            <p className="m-0">&nbsp;</p>
          </div>
          <img
            className="relative w-[33.75rem] h-[22.5rem] object-cover"
            alt=""
            src="/newxx@2x.png"
          />
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-gainsboro-100">
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>{`Visual Appeal: `}</b>
            <span>
              A fit and strong body is often visually appealing to many women.
              Well-defined muscles, a toned physique, and good overall physical
              condition convey a sense of vitality, health, and self-care. These
              physical attributes can catch the eye of women, who are naturally
              drawn to individuals who appear strong and capable.
            </span>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            <b className="font-dm-sans">{`Confidence and Presence: `}</b>
            <span>
              Physical fitness often correlates with increased confidence and
              self-assurance. Regular exercise and a strong body contribute to a
              positive body image, higher self-esteem, and improved posture.
              Confident individuals tend to exude a certain presence and
              charisma that captivates attention and draws people in, including
              women seeking a partner who is self-assured.
            </span>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            <b className="font-dm-sans">{`Symbol of Discipline and Dedication: `}</b>
            <span>
              Achieving and maintaining fitness requires discipline, dedication,
              and consistency. The commitment to a fitness routine demonstrates
              the ability to set goals, work hard, and persevere. Women are
              often attracted to individuals who exhibit determination and a
              strong work ethic, as these traits extend beyond the gym and are
              indicative of a person's character.
            </span>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            <b className="font-dm-sans">{`Physical Strength and Protection: `}</b>
            <span>
              A strong body can evoke a sense of physical strength and
              protection, qualities that appeal to many women. Historically,
              physical strength has been associated with providing security and
              protection, and these instincts can still influence attraction. A
              fit and strong partner can create a feeling of safety and
              reassurance for women, which can contribute to their attraction.
            </span>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            <b className="font-dm-sans">{`Active Lifestyle and Shared Interests: `}</b>
            <span>
              Fitness enthusiasts often lead an active lifestyle, participating
              in various physical activities and outdoor adventures. This can
              align with the interests of many women who appreciate partners who
              enjoy an active life. Shared interests and activities can foster
              deeper connections and provide opportunities for bonding and
              shared experiences.
            </span>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            <b className="font-dm-sans">Overall Health and Longevity:</b>
            <span>
              {" "}
              Being fit and having a strong body reflects a commitment to health
              and well-being. Women are often drawn to partners who prioritize
              their physical and mental health. A fit and healthy individual is
              seen as more likely to lead a fulfilling life and potentially have
              a longer life expectancy, qualities that are attractive in a
              potential partner.
            </span>
          </p>
        </div>
      </div>
      <a className="cursor-pointer text-darkgray no-underline" href={"/lesson18"}>
        <div className="rounded-32xl bg-gainsboro-200 box-border w-[25rem] flex flex-col items-center justify-center pt-[0.69rem] px-[3rem] pb-[1rem] max-w-[31.25rem] text-center text-[1.88rem] border-[1px] border-solid border-gray-300">
          <b className="self-stretch relative">Next Chapter</b>
        </div>
      </a>
    </div>
  );
};

export default Lesson17;
